<template>
  <b-navbar toggleable="sm" type="white" variant="white" class="border-bottom">
    <!-- <b-button variant="ligth">
            <font-awesome-icon icon="bars"></font-awesome-icon>
        </b-button> -->

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <div v-if="$route.name == 'Dashboard'" class="d-block position-relative align-items-center">
        <!-- <i
          style="font-size: 12px;margin-top: -10px; margin-bottom: 0; padding-bottom: 0; color: orange;"
          >Journal Account Balance Now</i
        > -->
        <!-- <div class="marquee">
          <div>
            <span v-for="data in dataText" :key="data.id">
             <p style="color: #4f3000; font-weight: 600;">
               {{ data.text }} <span style="color: green; margin-left: -2px;">{{data.money}}</span>
               </p>
              <p style="margin-top: -20px;font-weight: 600; font-size: 14px; color: orange;">{{data.date}}<b-badge variant="danger">Last Update</b-badge></p>
            </span>
          </div>
        </div> -->
      </div>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!-- <div class="d-flex">
                <font-awesome-icon icon="bell" style="margin-top:12px;"></font-awesome-icon>
                <span class="dot counter counter-lg">999</span>&nbsp;&nbsp;
              </div> -->

        <!-- <b-nav-item-dropdown right class="mr-3">
                  <template v-slot:button-content>
                    <font-awesome-icon icon="bell"></font-awesome-icon>
                    <span class="badge badge-danger badge-pill counter">99</span>
                  </template>
                  <b-dropdown-item href="#">List 1</b-dropdown-item>
                  <b-dropdown-item href="#">List 2</b-dropdown-item>
                </b-nav-item-dropdown> -->

        <b-nav-item-dropdown right class="text-dark">
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            {{ $store.getters['account/accountData'].firstName }}
            {{ $store.getters['account/accountData'].lastName }}
          </template>
          <div class="hovered">
            <b-dropdown-item href="#/profile" class="icon-profile ml-4"> Profile</b-dropdown-item>
          </div>
          <hr />
          <b-dropdown-item class="text-center" href="#/logout"
            ><b-button
              pill
              variant="danger"
              style="text-transform:uppercase!important; font-weight:bold!important; margin-top:-10px!important; font-size:13px!important;"
              ><font-awesome-icon icon="sign-out-alt"></font-awesome-icon> Log Out</b-button
            ></b-dropdown-item
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>
<script>
export default {
  data() {
    return {
      apiUrl: {
        journal: window.AppConfig.apiUrl + 'new-dashboard?journal_account',
      },
      words: [],
      dataRes: [],
      dataText: [],
      dataAccount: this.$store.getters['account/accountData'],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async getData() {
      const resp = await this.$http.get(this.apiUrl.journal);
      if (
        resp.data.journalAccountBankAndCash !== null ||
        resp.data.journalAccountBankAndCash !== undefined
      ) {
        this.dataRes = resp.data.journalAccountBankAndCash.forEach((data) => {
          this.dataText.push({
            id: data.journal_account_code,
            text:
              data.journal_account_name +
              ' ' ,
             
            date: this.getDateTime(data.updated_at),
            money:  this.dataAccount.account.currency +
              ' ' +
              this.formatPrice(data.journal_account_balance_now),
          });
        });
        this.dataText.forEach((text) => {
          this.words.push(text.text);
        });
      }
    },

    initData() {
      if (this.$route.name === 'Dashboard') {
        this.getData();
      }
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('DD MMM YYYY HH:mm');
      } else {
        return '-';
      }
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};
</script>

<style scoped>
.marquee {
  height: 45px;
  width: 1000px;
  z-index: 100;

  overflow: hidden;
  position: relative;
  justify-content: end;
}

.marquee div {
  display: block;
  width: 200%;
  height:430px;

  position: absolute;
  overflow: hidden;

  animation: marquee 38s linear infinite !important;
}

.marquee span {
  margin-right: 16px;
  margin-left: 16px;
  display: inline-block;
}

@keyframes marquee {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
</style>
